import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { HexPattern } from "./Bee";
import { SITE } from "../data/site";

export default function ContactBanner({
    testid = "contact-strip",
    title = "Come buzz by for a visit",
    sub = "Tour the hive, meet our teachers and see a day in the life. We would love to meet your family.",
}) {
    const items = [
        {
            icon: MapPin,
            label: "Visit us",
            value: SITE.address,
            testid: "contact-address",
        },
        {
            icon: Phone,
            label: "Call us",
            value: SITE.phone,
            href: SITE.phoneHref,
            testid: "contact-phone",
        },
        {
            icon: Mail,
            label: "Email",
            value: SITE.email,
            href: `mailto:${SITE.email}`,
            testid: "contact-email",
        },
        {
            icon: Clock,
            label: "Hours",
            value: SITE.hoursLine,
            testid: "contact-hours",
        },
    ];
    return (
        <section data-testid={testid} className="wrap pb-16 lg:pb-24">
            <div className="relative overflow-hidden rounded-[2.5rem] bg-honey px-6 py-12 sm:px-12 sm:py-14 lg:px-16">
                <HexPattern
                    className="absolute inset-0 h-full w-full"
                    stroke="#FFFFFF"
                    opacity={0.22}
                />
                <div className="relative grid items-center gap-10 lg:grid-cols-[1fr_1.1fr]">
                    <div>
                        <h2 className="font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl">
                            {title}
                        </h2>
                        <p className="mt-3 max-w-md leading-relaxed text-ink/70">
                            {sub}
                        </p>
                        <a
                            href={SITE.phoneHref}
                            data-testid="contact-book-tour-btn"
                            className="btn-white mt-7"
                        >
                            <Phone className="h-4 w-4" /> Book a Tour
                        </a>
                    </div>
                    <ul className="grid gap-3 sm:grid-cols-2">
                        {items.map((it) => (
                            <li
                                key={it.testid}
                                data-testid={it.testid}
                                className="flex items-start gap-3 rounded-2xl bg-white/85 p-4 backdrop-blur-sm"
                            >
                                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-honeysoft">
                                    <it.icon className="h-5 w-5 text-honey-warm" />
                                </span>
                                <span>
                                    <span className="block text-xs font-bold uppercase tracking-[0.14em] text-ink-soft">
                                        {it.label}
                                    </span>
                                    {it.href ? (
                                        <a
                                            href={it.href}
                                            className="mt-0.5 block font-medium text-ink transition-colors hover:text-honey-warm"
                                        >
                                            {it.value}
                                        </a>
                                    ) : (
                                        <span className="mt-0.5 block font-medium text-ink">
                                            {it.value}
                                        </span>
                                    )}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
